'use client';

import { RenderAd } from '@pickleballinc/ui/components/advertisements/render-ad';
import { isAdFreePath } from '@pickleballinc/ui/lib/freestar-ad-free-paths';
import { usePathname } from 'next/navigation';

import { ZONE_IDS_PL } from '@/types/ads.types';
import { PLACEMENT_IDS_PL } from '@/types/freestar.pl.types';
import { AD_FREE_PAGES, IS_PRODUCTION } from '@/utils/helpers/constants';

interface LeagueSessionLeaderboardProps {
  ipAddress: string;
}

/**
 * The leaderboard above the league session page — and the spacing that stands in for it.
 *
 * Client-side on purpose. `session/[sessionId]/layout.tsx` is shared with the game day route
 * nested beneath it (`/matchdate/<id>`), and Next preserves a shared layout across a client-side
 * navigation rather than re-rendering it. An `adFree` computed on the server therefore stays frozen
 * at whatever the session page decided, which is how the banner survived into game day.
 * `usePathname()` re-runs on every navigation, so the verdict here is fresh each time.
 *
 * Renders a `pt-4` spacer instead of nothing when ad-free, so content sits the same distance below
 * the header whichever way the page was reached.
 */
export const LeagueSessionLeaderboard = ({ ipAddress }: LeagueSessionLeaderboardProps) => {
  const pathname = usePathname();

  if (isAdFreePath(pathname, AD_FREE_PAGES)) return <div className='pt-4' />;

  return (
    <RenderAd
      placementId={PLACEMENT_IDS_PL.leaderboard_atf}
      zoneId={ZONE_IDS_PL.PROG_BANNER}
      pageId={100015}
      place={0}
      ipAddress={ipAddress}
      containerClassname='my-4 mx-auto'
      isProd={IS_PRODUCTION}
    />
  );
};
